// extracted by mini-css-extract-plugin
export default {"root":"NewScheduleSelect_root__kTLTX"};